import { UseInfiniteQueryOptions } from 'react-query';

import { fetchSituations } from '@api/chatbot';
import { QUERY_KEYS } from '@constants';
import { useChatPaginationQuery } from '@utils/query';

import { IChatPagination, IChatSituationInfo } from './../../model.d';

export const useSituationQuery = () => {
  const useGetSituationsByCharacterGroup = (
    characterId: number,
    sort: 'desc' | 'asc' = 'desc',
    options: Partial<
      UseInfiniteQueryOptions<IChatPagination<IChatSituationInfo>>
    > = {}
  ) => {
    const situationQueryKey = QUERY_KEYS.SITUATION.INFO(characterId);

    const query = useChatPaginationQuery(
      situationQueryKey,
      ({ pageParam }) =>
        fetchSituations(
          {
            character_id: characterId,
            status: 'AT',
            sort: sort,
          },
          pageParam
        ),
      {
        ...options,
      }
    );

    return query;
  };

  return { useGetSituationsByCharacterGroup };
};
